import { j as i } from "../../jsx-runtime-B6kdoens.js";
import { c as d } from "../../index-CROKJrb5.js";
import { c as b, f } from "../../create-component-CBAeEoQ6.js";
const p = d({
  base: "cur-border-t-3 cur-no-underline",
  variants: {
    size: {
      md: "cur-text-meta cur-px-1 cur-pt-[1px] cur-pb-[2px]",
      lg: "cur-text-body cur-px-2 cur-pt-[2px] cur-pb-[3px]"
    },
    disabled: {
      true: "cur-text-disabled hover:cur-text-disabled cur-border-t-disabled cur-bg-surface-disabled",
      false: "cur-text-subtle focus-visible:cur-ring-offset-0 cur-outline-none focus-visible:cur-ring-offset-brand hover:cur-text-white hover:cur-no-underline cur-border-t-brand hover:cur-bg-surface-brand"
    },
    tagType: {
      default: null,
      highlight: null
    }
  },
  compoundVariants: [
    {
      disabled: !1,
      tagType: "default",
      className: "cur-bg-surface-primary"
    },
    {
      disabled: !1,
      tagType: "highlight",
      className: "cur-bg-surface-neutral"
    }
  ]
}), h = b(
  "Tag",
  f(
    ({
      as: t,
      children: a,
      className: u,
      href: e,
      disabled: r = !1,
      size: s = "md",
      tagType: c = "default",
      ...o
    }, l) => {
      const n = t || e ? "a" : "button";
      return /* @__PURE__ */ i.jsx(
        n,
        {
          ref: l,
          className: p({
            className: u,
            tagType: c,
            disabled: r,
            size: s
          }),
          href: r ? void 0 : e,
          type: "button",
          ...o,
          children: a
        }
      );
    }
  )
);
export {
  h as Tag
};
//# sourceMappingURL=index.js.map
